// `guid`, `callbackObj`, `isElectron`, `isReactNative`, `isSenchaParent`, `isStandaloneWeb`,
// `exec` and `isAndroid` moved to @rista/core/utils/nativeHooks (WEB variant + shared.ts).
//
// IMPORTED as well as re-exported, because this file's own body still calls them:
// `isAndroidOrSmDevice` calls `isAndroid`. `guid` is imported by neither — it moved WITH `exec`,
// the only thing here that used it — and it is NOT re-exported, because the app file never
// exported it.
//
// `callbackObj` must stay ONE object per bundle: core's `exec` writes to it and
// `OfflineUtil.handleGetCallback` reads it back. Re-exporting core's binding is what guarantees
// that; declaring a local `{}` here would silently break every native callback.
import { isAndroid } from "@rista/core/utils/nativeHooks";
import { isEmpty } from "lodash";
import { isMobileView } from "../helper/commonHelpers";

export {
  callbackObj,
  isAndroid,
  isElectron,
  isReactNative,
  isSenchaParent,
  isStandaloneWeb,
  exec,
} from "@rista/core/utils/nativeHooks";

// Moved to @rista/core/utils/nativeHooks (shared.ts — byte-identical in both apps). Core reads
// the host global through the effects bridge, since packages/core has no DOM lib.
export { sendDataToApp } from "@rista/core/utils/nativeHooks";

export const printbill = (printer) => {
  if (!isEmpty(printer?.enableLabelPrinter)) {
    return window.RL.bill.getTestPrintLabelContent({
      label: printer?.label,
      ip: printer?.ip,
      port: printer?.port,
      printWidth: printer?.printWidth,
    });
  }
  return window.RL.bill.getTestPrintContent({
    maxChars: "",
    label: printer?.label,
    ip: printer?.ip,
    port: printer?.port,
    contentType: printer?.contentType,
  });
};

export const isAndroidOrSmDevice = () => {
  return isAndroid() || isMobileView();
}
